<template>
  <v-menu
    class="v-menu"
    left
    origin="center center"
    transition="scale-transition"
    :data-testid="`${params.testId ? `${params.testId}__` : ''}MenuItem`"
  >
    <v-btn slot="activator" icon>
      <v-icon color="#526da5">more_vert</v-icon>
    </v-btn>

    <v-list v-show="mostrarMenuAcciones">
      <v-list-tile style="height: 40px" v-if="btnVerPdf">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerPdf)">
            <v-icon small color="#526da5">{{ btnVerIcon }}</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerPdf)"
          >{{ btnVerText }}</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnDejarDeRecibir">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.DejarRecibirInformacion)"
          >
            <v-icon small color="#526da5">block</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.DejarRecibirInformacion)"
          >Dejar de recibir</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnAceptar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.AceptarInformacionCompartida)"
          >
            <v-icon small color="#526da5">done</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.AceptarInformacionCompartida)"
          >Aceptar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnRechazar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.RechazarInformacionCompartida)"
          >
            <v-icon small color="#526da5">clear</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.RechazarInformacionCompartida)"
          >Rechazar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnVerDetalle">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerDetalle)">
            <v-icon small color="#526da5">info</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerDetalle)"
          >{{ btnVerDetalleText }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEditar"
        :disabled="!enabledEditBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.Editar)"
            :disabled="!enabledEditBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Editar)"
          >Editar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnImportar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.accionImportar)">
            <v-icon small color="#526DA5">cloud_upload</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.accionImportar)"
          >Importar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnCargarArchivo"
        :disabled="!enabledEditBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.cargarArchivo)"
            :disabled="!enabledEditBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.cargarArchivo)"
          >{{ btnCargarArchivoTexto }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnRevertirEjecucion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.accionRevertirEjecucion)"
          >
            <v-icon small color="#526DA5">settings_backup_restore</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.accionRevertirEjecucion)"
          >Revertir Ejecución</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEliminar"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.Eliminar)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">delete</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Eliminar)"
          >Eliminar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEditarApn"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarApn)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarApn)"
          >{{ texto_editar }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnVerHistorico">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerHistorico)">
            <v-icon small color="#526da5">manage_search</v-icon>
          </v-btn>
        </v-list-tile-avatar>

        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerHistorico)"
          >Ver Historial De Estados</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEliminarApn"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EliminarApn)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">delete</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EliminarApn)"
          >{{ texto_eliminar }}</v-list-tile-title
        >
      </v-list-tile>
      <!----------------- plan -->
      <v-list-tile
        style="height: 40px"
        v-if="btnEditarPlan"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarPlan)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarPlan)"
          >Editar Plan</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEliminarPlan"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EliminarPlan)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">delete</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EliminarPlan)"
          >Eliminar Plan</v-list-tile-title
        >
      </v-list-tile>
      <!-- -------------------------- Fin plan -->
      <!----------------- Apn Crear -->
      <v-list-tile
        style="height: 40px"
        v-if="btnEditarApnCrear"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarApnCrear)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarApnCrear)"
          >Editar Apn</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEliminarApnCrear"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EliminarApnCrear)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">delete</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EliminarApnCrear)"
          >Eliminar Apn</v-list-tile-title
        >
      </v-list-tile>
      <!-- -------------------------- Fin apn Crear -->
      <!----------------- Stock Crear -->
      <v-list-tile
        style="height: 40px"
        v-if="btnEditarStockCrear"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarStockCrear)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarStockCrear)"
          >Editar Stock</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile
        style="height: 40px"
        v-if="btnEliminarStockCrear"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EliminarStockCrear)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">delete</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EliminarStockCrear)"
          >Eliminar Stock</v-list-tile-title
        >
      </v-list-tile>
      <!-- -------------------------- Fin Stock Crear -->
      <v-list-tile
        style="height: 40px"
        v-if="btnEditarStock"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarStock)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarStock)"
          >Editar Stock</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile
        style="height: 40px"
        v-if="btnEliminarStock"
        :disabled="!enabledDeleteBtn"
      >
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EliminarStock)"
            :disabled="!enabledDeleteBtn"
          >
            <v-icon small color="#526da5">delete</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EliminarStock)"
          >{{ texto_eliminar_p }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnDejarDeCompartir">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.NoRecibirInformacion)"
          >
            <v-icon small color="#526da5">block</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.NoRecibirInformacion)"
          >Dejar de compartir</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnCancelar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Cancelar)">
            <v-icon small color="#526da5">block</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Cancelar)"
          >Cancelar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnDesbloquear">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Desbloquear)">
            <v-icon small color="#526da5">lock</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Desbloquear)"
          >{{ btnDesbloquearText }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnVerReferencia">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerReferencia)">
            <v-icon small color="#526da5">{{ btnVerReferenciaIcon }}</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerReferencia)"
          >{{ btnVerReferenciaText }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnExportarCRM">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Exportar_A_CRM)">
            <v-icon small color="#526da5">ios_share</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Exportar_A_CRM)"
          >Exportar a CRM</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnDescargar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Descargar)">
            <v-icon small color="#526da5">cloud_download</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Descargar)"
          >Descargar {{ btnDescargarText }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnCambiarContraseña">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="changePassword">
            <v-icon small color="#526da5">key</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="changePassword"
          >Cambiar Contraseña</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnEnviar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Enviar)">
            <v-icon small color="#526da5">send</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Enviar)"
          >{{ btnEnviarText }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnCompartir">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.compartir)">
            <v-icon small color="#526da5">share</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.compartir)"
          >{{ this.btnCompartirTexto }}</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnAsociarGps">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.AsociarGps)">
            <v-icon small color="#526da5">add</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.AsociarGps)"
          >Asociar Gps</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnAnular">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Anular)">
            <v-icon small color="#526DA5">lock</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Anular)"
          >Anular</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnFacturar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Facturar)">
            <v-icon small color="#526DA5">task</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Facturar)"
          >Informar Facturada</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnSolicitarAutorizacion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.SolicitarAutorizacion)"
          >
            <v-icon small color="#526DA5">check</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.SolicitarAutorizacion)"
          >Solicitar Autorización</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnEditarAutorizadores">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarAutorizadores)"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>

        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarAutorizadores)"
          >Editar Autorizadores</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnIncluirCostosImportacion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.IncluirCostosImportacion)"
          >
            <v-icon small color="#526da5">search</v-icon>
          </v-btn>
        </v-list-tile-avatar>

        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.IncluirCostosImportacion)"
          >Ver Costos De Importación</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnVerAutorizacion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerAutorizacion)">
            <v-icon small color="#526DA5">info</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerAutorizacion)"
          >Ver Autorización</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnEditarReporteTecnico">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn
            small
            icon
            @click="handleItemClick(Accion.EditarReporteTecnico)"
          >
            <v-icon small color="#526da5">edit</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.EditarReporteTecnico)"
          >Editar Reporte Técnico</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnExistenciaEquipo">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerDetalleSeries)">
            <v-icon small color="#526DA5">info</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerDetalleSeries)"
          >Ver Detalle de Serie</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnInformarRecepcion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.InformarRecepcion)">
            <v-icon small color="#526DA5">task</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.InformarRecepcion)"
          >Informar Recepción</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnVerEstadoSeries">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.VerEstadoSeries)">
            <v-icon small color="#526DA5">search</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.VerEstadoSeries)"
          >Ver Estado Series</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px;" v-if="btnDevolverSeriado">
        <v-list-tile-avatar style="min-width: 35px;">
          <v-btn small icon @click="handleItemClick(Accion.DevolverSeriado)">
            <v-icon small color="#526da5">assignment_return</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: #000000b3;"
          @click="handleItemClick(Accion.DevolverSeriado)"
        >
          Devolver Serie
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnFinalizar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Finalizar)">
            <v-icon small color="#526DA5">check_circle</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Finalizar)"
          >Finalizar</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnGenerarAtencion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.AgregarEquipos)">
            <v-icon small color="#526DA5">add_circle</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.AgregarEquipos)"
        >
          Agregar Equipo
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnGestionarDespacho">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.GestionarDespacho)">
            <v-icon small color="#526DA5">local_shipping</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.GestionarDespacho)"
        >
          Gestionar Despacho
        </v-list-tile-title>
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnExportar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.exportar)">
            <v-icon small color="#526da5">ios_share</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.exportar)"
          >Exportar</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnGerarEnvio">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.accionGenerarEnvio)">
            <v-icon small color="#526da5">send</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.accionGenerarEnvio)"
          >Generar Envío</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnDevolverAFinanzas">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.DevolverAFinanzas)">
            <v-icon small color="#526da5">send</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.DevolverAFinanzas)"
          >Generar Envío</v-list-tile-title
        >
      </v-list-tile>

      <v-list-tile style="height: 40px" v-if="btnGenerarRecepcion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.GenerarRecepcion)">
            <v-icon small color="#526DA5">settings</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.GenerarRecepcion)"
        >
          Generar Recepción
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnAgregarEquipos">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.AgregarEquipos)">
            <v-icon small color="#526DA5">add_circle</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.AgregarEquipos)"
        >
          Agregar Equipo
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnGestionarDespacho">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Finalizar)">
            <v-icon small color="#526DA5">check_circle</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Finalizar)"
          >Finalizar</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnverevidencias_fila">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.ver_evidencias)">
            <v-icon small color="#526DA5">camera</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.ver_evidencias)"
          >Ver Evidencias</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnGenerarMovimiento">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.GenerarMovimiento)">
            <v-icon small color="#526DA5">schedule_send</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.GenerarMovimiento)"
        >
          Generar Movimiento
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnGenerarEncomienda">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.GenerarEncomienda)">
            <v-icon small color="#526DA5">schedule_send</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.GenerarEncomienda)"
        >
          Generar Encomienda
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnCompletar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Completar)">
            <v-icon small color="#526DA5">check_circle</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Completar)"
          >Completar</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnValidar">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.Validar)">
            <v-icon small color="#526DA5">thumb_up</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.Validar)"
          >Validar</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnAnularReasignacion">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.AnularReasignacion)">
            <v-icon small color="#526DA5">clear</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.AnularReasignacion)"
          >Anular Reasignacion</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnActualizarEstado">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.ActualizarEstado)">
            <v-icon small color="#526DA5">update</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.ActualizarEstado)"
          >Actualizar Estado</v-list-tile-title
        >
      </v-list-tile>
      <v-list-tile style="height: 40px" v-if="btnActualizarNDV">
        <v-list-tile-avatar style="min-width: 35px">
          <v-btn small icon @click="handleItemClick(Accion.ActualizarNDV)">
            <v-icon small color="#526DA5">update</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-title
          style="cursor: pointer; font-size: 13px; color: rgba(0, 0, 0, 0.7)"
          @click="handleItemClick(Accion.ActualizarNDV)"
          >Actualizar Nota de Ventas</v-list-tile-title
        >
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue';
import {
  EstadoEntidad,
  EstadoAceptarInformacion,
  EstadoCompartirInformacion,
  TipoUsuario,
  TipoRol,
  ServicioProxy,
} from '@/config/enums';
import { actionsEvent } from '@/setup';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';
import { Accion } from '@/config/enums';
import { CodigoAccion } from '../views/base/VariablesPermisos';
import { AxiosVue } from '@/AxiosVue';

export default Vue.extend({
  data: function() {
    return {
      Accion,
      estadoEntidad: EstadoEntidad.Activo,
      enabledDeleteBtn: true,
      enabledEditBtn: true,
      mostrarMenuAcciones: false,
      //botones deben ser variables no props, para cambiar
      //su estado sin necesidad de data computed
      btnDejarDeCompartir: false,
      btnDejarDeRecibir: false,
      btnEliminar: true,
      btnEliminarApn: false,
      btnEditarApn: false,
      btnEliminarPlan: false,
      btnEditarPlan: false,
      btnEliminarApnCrear: false,
      btnEditarApnCrear: false,
      btnEliminarStockCrear: false,
      btnEditarStockCrear: false,
      btnEditar: true,
      btnVerDetalle: true,
      btnVerDetalleText: 'Ver Detalle',
      btnAceptar: false,
      btnRechazar: false,
      btnDesbloquear: false,
      btnCancelar: false,
      btnDesbloquearText: 'Bloquear',
      btnDescargar: false,
      btnExportarCRM: false,
      btnExportar: false,
      btnGerarEnvio: false,
      btnCambiarContraseña: false,
      axios: null,
      btnEnviar: false,
      btnEnviarText: '',
      btnDescargarText: '',
      btnVerPdf: false,
      btnVerText: 'Ver PDF',
      btnVerIcon: 'picture_as_pdf',
      btnVerReferencia: false,
      btnVerReferenciaIcon: 'receipt_long',
      btnVerReferenciaText: 'Ver Referencia',
      btnAnular: false,
      btnFacturar: false,
      btnEditarStock: false,
      btnEliminarStock: false,
      btnCargarArchivo: false,
      btnCargarArchivoTexto: 'Cargar Archivo',
      btnCompartir: false,
      btnCompartirTexto: 'Compartir',
      btnVerHistorico: false,
      btnEditarAutorizadores: false,
      btnIncluirCostosImportacion: false,
      btnSolicitarAutorizacion: false,
      btnVerAutorizacion: false,
      btnInformarRecepcion: false,
      btnVerEstadoSeries: false,
      texto_editar: 'Editar APN',
      texto_eliminar: 'Eliminar APN',
      texto_eliminar_p: 'Eliminar Stock',
      btnImportar: false,
      btnRevertirEjecucion: false,
      btnGenerarAtencion: false,
      btnAccionReutilizable: false,
      btnFacturacionEspecial: false,
      btnAsociarGps: false,
      textoAccionReutilizable: 'Ver',
      iconoAccionReutilizable: 'info',
      btnFinalizar: false,
      btnverevidencias_fila: false,
      btnGenerarRecepcion: false,
      btnGestionarDespacho: false,
      btnAgregarEquipos: false,
      btnverevidencias_fila: false,
      btnGenerarMovimiento: false,
      btnGenerarEncomienda: false,
      btnCompletar: false,
      btnValidar: false,
      btnAnularReasignacion: false,
      btnActualizarEstado: false,
      btnActualizarNDV: false,
    };
  },
  props: {
    usuario: {
      type: Object,
      default: null,
    },
    funcionalidad: {
      type: Funcionalidades,
      default: null,
    },
    acciones: {
      type: [],
      default: null,
    },
    codigoAccionesMenuItem: {
      type: [],
      default: null,
    },
    contextoAccionReutilizable: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    changePassword() {
      let url = '';
      let arr = [];
      arr = window.location.pathname.split('/');
      if (arr.length >= 3) {
        url = window.location.origin + '/' + arr[1];
      } else {
        url = window.location.origin;
      }
      const hor = new Date().getHours();
      const min = new Date().getMinutes();
      const dia = new Date().getDate();
      const mes = new Date().getMonth();
      const horStr = hor > 9 ? hor.toString() : '0' + hor.toString();
      const minStr = min > 9 ? min.toString() : '0' + min.toString();
      const diaStr = dia > 9 ? dia.toString() : '0' + dia.toString();
      const mesStr = mes > 9 ? mes.toString() : '0' + mes.toString();
      const anoStr = new Date().getFullYear().toString();
      let model = {
        EncodeIdUsuario: btoa(this.params.data.id.toString()),
        To: this.params.data.email,
        EncodedFechaEnvio: btoa(
          minStr + horStr + diaStr + mesStr + anoStr + this.params.data.email
        ),
        Url: url,
      };
      this.axios = new AxiosVue(ServicioProxy.Auth);
      this.axios.http
        .post(`Email/LinkReestablecerPassword`, model)
        .then(res => {
          actionsEvent.$emit('envioLink', res.data);
        })
        .catch(err => {
          //this.$snotify.error('Ocurrio un error al enviar correo.');
        });
    },
    handleItemClick(action) {
      actionsEvent.$emit('actionsEvent', {
        funcionalidad: this.params.funcionalidad,
        action,
        id:
          action === Accion.Eliminar &&
          this.estadoEntidad == EstadoEntidad.Eliminado
            ? -1
            : this.params.value,
        cellRendererParams: this.params,
      });
    },
    chequearPermisos() {
      let boolPermisos = false;
      if (this.params.codigoAccionesMenuItem.length > 0) {
        for (let i = 0; i < this.params.codigoAccionesMenuItem.length; i++) {
          const permiso = this.params.codigoAccionesMenuItem[i];
          let accion = this.params.usuario.permisosUsuario.find(
            x =>
              x.moduloCodigo === this.params.funcionalidad &&
              x.accionCodigo === permiso &&
              x.clienteId === config.getClienteSesion()
          );

          // boolean para permisos
          if (accion !== undefined && accion !== null) {
            boolPermisos = true;
          }
          //---
        }
        // Autorizaciones
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionSolicitarAutorizacion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.SolicitarAutorizacion &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          accionSolicitarAutorizacion !== undefined &&
          accionSolicitarAutorizacion !== null
        ) {
          this.btnSolicitarAutorizacion = true;
        } else {
          this.btnSolicitarAutorizacion = false;
        }

        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionVerAutorizacion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerAutorizacion &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          accionVerAutorizacion !== undefined &&
          accionVerAutorizacion !== null
        ) {
          this.btnVerAutorizacion = true;
        } else {
          this.btnVerAutorizacion = false;
        }
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }

        // Asociar Gps
        const accionAsociarGps = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.AsociarGps &&
            x.clienteId === config.getClienteSesion()
        );
        this.btnAsociarGps = accionAsociarGps ? true : false;

        const accionVerEstadoSeries = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerEstadoSeries &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          accionVerEstadoSeries !== undefined &&
          accionVerEstadoSeries !== null
        ) {
          this.btnVerEstadoSeries = true;
        } else {
          this.btnVerEstadoSeries = false;
        }
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionInformarRecepcion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.InformarRecepcion &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          accionInformarRecepcion !== undefined &&
          accionInformarRecepcion !== null
        ) {
          this.btnInformarRecepcion = true;
        } else {
          this.btnInformarRecepcion = false;
        }
        // Fin Autorizaciones
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionAnular = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Anular &&
            x.clienteId === config.getClienteSesion()
        );
        if (accionAnular !== undefined && accionAnular !== null) {
          this.btnAnular = true;
        } else {
          this.btnAnular = false;
        }
        /////////// Facturar Atencion
        const accionFacturar = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Facturar &&
            x.clienteId === config.getClienteSesion()
        );
        if (accionFacturar !== undefined && accionFacturar !== null) {
          this.btnFacturar = true;
        } else {
          this.btnFacturar = false;
        }
        ////////// Actualizar Estado
        const accionActualizarEstado = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.ActualizarEstado &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          accionActualizarEstado !== undefined &&
          accionActualizarEstado !== null
        ) {
          this.btnActualizarEstado = true;
        } else {
          this.btnActualizarEstado = false;
        }
        ////////// Elminar Apn Crear
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionElimnarApnCrear = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EliminarApnCrear &&
            x.clienteId === config.getClienteSesion()
        );

        if (
          accionElimnarApnCrear !== undefined &&
          accionElimnarApnCrear !== null
        ) {
          this.btnEliminarApnCrear = true;
        } else {
          this.btnEliminarApnCrear = false;
        }
        ////////////////////////// Editar apn Crear
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionEditarApnCrear = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EditarApnCrear &&
            x.clienteId === config.getClienteSesion()
        );

        if (
          accionEditarApnCrear !== undefined &&
          accionEditarApnCrear !== null
        ) {
          this.btnEditarApnCrear = true;
        } else {
          this.btnEditarApnCrear = false;
        }
        const importarAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.accionImportar &&
            x.clienteId === config.getClienteSesion()
        );

        if (importarAccion !== undefined && importarAccion !== null) {
          this.btnImportar = true;
        } else {
          this.btnImportar = false;
        }

        const revertirEjecucion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.accionRevertirEjecucion &&
            x.clienteId === config.getClienteSesion()
        );
        if (revertirEjecucion !== undefined && revertirEjecucion !== null) {
          this.btnRevertirEjecucion = true;
        } else {
          this.btnRevertirEjecucion = false;
        }

        const exportarAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Exportar &&
            x.clienteId === config.getClienteSesion()
        );
        if (exportarAccion !== undefined && exportarAccion !== null) {
          this.btnExportar = true;
        } else {
          this.btnExportar = false;
        }

        const generarEnvio = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.GenerarEnvio &&
            x.clienteId === config.getClienteSesion()
        );
        if (generarEnvio !== undefined && generarEnvio !== null) {
          this.btnGerarEnvio = true;
        } else {
          this.btnGerarEnvio = false;
        }

        const devolverafinanzas = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.accionDevolverAFInanzas &&
            x.clienteId === config.getClienteSesion()
        );
        console.log(
          'funcionalidad=' +
            this.params.funcionalidad +
            '    codigoAccion=' +
            CodigoAccion.accionDevolverAFInanzas +
            '   cliente=' +
            config.getClienteSesion()
        );
        if (devolverafinanzas !== undefined && devolverafinanzas !== null) {
          this.btnDevolverAFinanzas = true;
        } else {
          this.btnDevolverAFinanzas = false;
        }

        //////////////
        ////////// Elminar Apn
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionElimnarApn = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EliminarApn &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          this.params.funcionalidad ===
          Funcionalidades.PreparacionEquiposSeriados
        ) {
          this.texto_eliminar = 'Eliminar Serie';
        }

        if (accionElimnarApn !== undefined && accionElimnarApn !== null) {
          this.btnEliminarApn = true;
        } else {
          this.btnEliminarApn = false;
        }
        ////////////////////////// Editar apn
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionEditarApn = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EditarApn &&
            x.clienteId === config.getClienteSesion()
        );
        if (
          this.params.funcionalidad ===
          Funcionalidades.PreparacionEquiposSeriados
        ) {
          this.texto_editar = 'Editar Serie';
        }
        if (accionEditarApn !== undefined && accionEditarApn !== null) {
          this.btnEditarApn = true;
        } else {
          this.btnEditarApn = false;
        }

        //////////////
        ////////// Elminar Plan
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionElimnarPlan = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EliminarPlanCrear &&
            x.clienteId === config.getClienteSesion()
        );

        if (accionElimnarPlan !== undefined && accionElimnarPlan !== null) {
          this.btnEliminarPlan = true;
        } else {
          this.btnEliminarPlan = false;
        }
        ////////////////////////// Editar Plan
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionVerHistorico = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerHistorico &&
            x.clienteId === config.getClienteSesion()
        );

        if (accionVerHistorico !== undefined && accionVerHistorico !== null) {
          this.btnVerHistorico = true;
        } else {
          this.btnVerHistorico = false;
        }

        const accionEditarAutorizadores = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EditarAutorizadores &&
            x.clienteId === config.getClienteSesion()
        );

        if (
          accionEditarAutorizadores !== undefined &&
          accionEditarAutorizadores !== null
        ) {
          this.btnEditarAutorizadores = true;
        } else {
          this.btnEditarAutorizadores = false;
        }

        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionEditarPlan = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EditarPlanCrear &&
            x.clienteId === config.getClienteSesion()
        );

        if (accionEditarPlan !== undefined && accionEditarPlan !== null) {
          this.btnEditarPlan = true;
        } else {
          this.btnEditarPlan = false;
        }

        //////////////
        ////////// Elminar Stock
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionElimnarStock = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EliminarStock &&
            x.clienteId === config.getClienteSesion()
        );
        if (this.params.funcionalidad === Funcionalidades.PreparacionEquipos) {
          this.texto_eliminar_p = 'Finalizar';
        }
        if (accionElimnarStock !== undefined && accionElimnarStock !== null) {
          this.btnEliminarStock = true;
        } else {
          this.btnEliminarStock = false;
        }
        ////////////////////////// Editar Stock
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionEditarStock = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EditarStock &&
            x.clienteId === config.getClienteSesion()
        );

        if (accionEditarStock !== undefined && accionEditarStock !== null) {
          this.btnEditarStock = true;
        } else {
          this.btnEditarStock = false;
        }

        //////////////
        ////////
        ////////// Elminar Stock
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionElimnarStockCrear = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EliminarStockCrear &&
            x.clienteId === config.getClienteSesion()
        );

        if (
          accionElimnarStockCrear !== undefined &&
          accionElimnarStockCrear !== null
        ) {
          this.btnEliminarStockCrear = true;
        } else {
          this.btnEliminarStockCrear = false;
        }
        ////////////////////////// Editar Stock
        if (boolPermisos) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
        const accionEditarStockCrear = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.EditarStockCrear &&
            x.clienteId === config.getClienteSesion()
        );

        if (
          accionEditarStockCrear !== undefined &&
          accionEditarStockCrear !== null
        ) {
          this.btnEditarStockCrear = true;
        } else {
          this.btnEditarStockCrear = false;
        }

        //////////////
        const editarAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Editar &&
            x.clienteId === config.getClienteSesion()
        );

        if (editarAccion !== undefined && editarAccion !== null) {
          this.btnEditar = true;
        } else {
          this.btnEditar = false;
        }

        const finalizaraccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Finalizar &&
            x.clienteId === config.getClienteSesion()
        );
        if (finalizaraccion !== undefined && finalizaraccion !== null) {
          this.btnFinalizar = true;
        } else {
          this.btnFinalizar = false;
        }

        const ver_evidencia_fila = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.ver_evidencias &&
            x.clienteId === config.getClienteSesion()
        );
        if (ver_evidencia_fila !== undefined && ver_evidencia_fila !== null) {
          this.btnverevidencias_fila = true;
        } else {
          this.btnverevidencias_fila = false;
        }

        const CargarArchivoAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.cargarArchivo &&
            x.clienteId === config.getClienteSesion()
        );

        if (CargarArchivoAccion !== undefined && CargarArchivoAccion !== null) {
          this.btnCargarArchivo = true;
          if (this.params.funcionalidad == 147) {
            this.btnCargarArchivoTexto = 'Cargar Excel Series';
          } else {
            this.btnCargarArchivoTexto = 'Cargar Archivo';
          }
        } else {
          this.btnCargarArchivo = false;
        }

        /*    */
        const compartirAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.compartir &&
            x.clienteId === config.getClienteSesion()
        );

        if (compartirAccion !== undefined && compartirAccion !== null) {
          this.btnCompartir = true;
          if (this.params.funcionalidad == 147) {
            this.btnCompartirTexto = 'Exportar Excel INET';
          } else {
            this.btnCompartirTexto = 'Compartir';
          }
        } else {
          this.btnCompartir = false;
        }

        const IncluirCostosAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.IncluirCostosImportacion &&
            x.clienteId === config.getClienteSesion()
        );

        if (IncluirCostosAccion !== undefined && IncluirCostosAccion !== null) {
          this.btnIncluirCostosImportacion = true;
        } else {
          this.btnIncluirCostosImportacion = false;
        }

        /*    */
        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );
        if (verDetalle !== undefined && verDetalle !== null) {
          this.btnVerDetalle = true;
        } else {
          this.btnVerDetalle = false;
        }
        if (this.params.funcionalidad === Funcionalidades.PreparacionEquipos) {
          this.btnVerDetalleText = 'Editar Detalle';
        }

        const exportarCRMAccion = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Exportar_A_CRM &&
            x.clienteId === config.getClienteSesion()
        );
        if (exportarCRMAccion !== undefined && exportarCRMAccion !== null) {
          this.btnExportarCRM = true;
        } else {
          this.btnExportarCRM = false;
        }

        const Eliminar = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Eliminar &&
            x.clienteId === config.getClienteSesion()
        );
        if (Eliminar !== undefined && Eliminar !== null) {
          this.btnEliminar = true;
        } else {
          this.btnEliminar = false;
        }
      }
      if (this.params.funcionalidad === Funcionalidades.Clientes) {
        this.btnEliminar = false;
        if (this.btnEditar == false && this.btnVerDetalle == false) {
          this.mostrarMenuAcciones = false;
        }
      }
      if (this.params.funcionalidad === Funcionalidades.VerFacturacion) {
        this.btnVerDetalleText = 'Detalle Documento';
        this.btnDescargarText = 'Todo';
      }

      if (this.params.funcionalidad == Funcionalidades.Importar) {
        this.btnEliminar = false;

        const cancelar = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Cancelar &&
            x.clienteId === config.getClienteSesion()
        );
        if (cancelar !== undefined && cancelar !== null) {
          if (this.params.data.estadoImportar == 1) {
            this.btnCancelar = true;
          } else {
            this.btnCancelar = false;
          }
        }

        //[Entrega3 - B521] Perfilamiento - Importar
        if (!this.btnVerDetalle && !this.btnCancelar && !this.btnEliminar)
          this.mostrarMenuAcciones = false;
        //---
      }

      const codigosGestionarDespacho = [
        CodigoAccion.AgregarEquipos,
        CodigoAccion.GenerarMovimiento,
        CodigoAccion.GenerarEncomienda,
        CodigoAccion.GestionarDespacho,
      ];
      const gestionarDespacho = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          codigosGestionarDespacho.includes(x.accionCodigo) &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnGestionarDespacho = gestionarDespacho ? true : false;

      // Generar Movimiento
      const generarMovimiento = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.GenerarMovimiento &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnGenerarMovimiento = generarMovimiento ? true : false;

      // Generar Encomienda
      const generarEncomienda = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.GenerarEncomienda &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnGenerarEncomienda = generarEncomienda ? true : false;

      const desbloquear = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.Desbloquear &&
          x.clienteId === config.getClienteSesion()
      );
      if (desbloquear !== undefined && desbloquear !== null) {
        if (this.params.funcionalidad === Funcionalidades.UsuariosTransversal) {
          this.btnDesbloquear = true;

          if (this.params.data.estado === EstadoEntidad.Activo) {
            this.btnDesbloquearText = 'Bloquear';
          } else if (
            this.params.data.estado === EstadoEntidad.BloqueadoPorEjecutivo
          ) {
            this.btnDesbloquearText = 'Desbloquear';
          } else {
            this.btnDesbloquear = false;
            if (!this.btnVerDetalle && !this.btnEditar && !this.btnEliminar)
              this.mostrarMenuAcciones = false;
          }
        }

        if (this.params.funcionalidad == Funcionalidades.Usuarios) {
          this.btnDesbloquear = true;
          if (this.params.data.tipo != TipoUsuario.Transversal) {
            if (this.params.data.estado === EstadoEntidad.Activo) {
              this.btnDesbloquearText = 'Bloquear';
            } else if (
              this.params.data.estado === EstadoEntidad.BloqueadoPorEjecutivo
            ) {
              this.btnDesbloquearText = 'Desbloquear';
            } else {
              this.btnDesbloquear = false;
              if (!this.btnVerDetalle && !this.btnEditar && !this.btnEliminar)
                this.mostrarMenuAcciones = false;
            }
          } else {
            this.btnDesbloquear = false;
            if (!this.btnVerDetalle && !this.btnEditar && !this.btnEliminar)
              this.mostrarMenuAcciones = false;
          }
        }
      } else {
        this.btnDesbloquear = false;
      }

      if (this.params.funcionalidad == Funcionalidades.CamarasVOD) {
        this.btnCancelar = false;

        const cancelar = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Cancelar &&
            x.clienteId === config.getClienteSesion()
        );
        if (cancelar !== undefined && cancelar !== null) {
          this.btnCancelar = true;
        } else {
          this.btnCancelar = false;
        }
      }

      if (this.params.funcionalidad == Funcionalidades.AlertasVigilanti) {
        this.btnEnviar = false;
        const enviar = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.Enviar &&
            x.clienteId === config.getClienteSesion()
        );

        if (enviar !== undefined && enviar !== null) {
          this.btnEnviar = true;
        } else {
          this.btnEnviar = false;
        }
      }

      const generarAtencion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.GenerarAtencion &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnGenerarAtencion = generarAtencion ? true : false;
      const facturacion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.FacturacionManual &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnFacturacionEspecial = generarAtencion ? true : false;

      const AccionReutilizable = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.AccionReutilizable &&
          x.clienteId === config.getClienteSesion()
      );

      if (AccionReutilizable) {
        this.btnAccionReutilizable = true;
        this.textoAccionReutilizable = this.params.contextoAccionReutilizable[0]
          ? this.params.contextoAccionReutilizable[0]
          : this.textoAccionReutilizable;
        this.iconoAccionReutilizable = this.params.contextoAccionReutilizable[1]
          ? this.params.contextoAccionReutilizable[1]
          : this.iconoAccionReutilizable;
      }

      const generarRecepcion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.GenerarRecepcion &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnGenerarRecepcion = generarRecepcion ? true : false;

      const agregarEquipos = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.AgregarEquipos &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnAgregarEquipos = agregarEquipos ? true : false;

      const devolverSeriado = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.DevolverSeriado &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnDevolverSeriado = devolverSeriado ? true : false;
      const actualizarNDV = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.ActualizarNDV &&
          x.clienteId === config.getClienteSesion()
      );
      this.btnActualizarNDV = actualizarNDV ? true : false;
    },
  },
  beforeMount() {
    this.chequearPermisos();
    if (this.params.funcionalidad === Funcionalidades.Vehiculos) {
      if (
        this.params.data.esCompartido !== undefined &&
        this.params.data.esCompartido === true
      ) {
        this.btnEliminar = false;
      }
    }

    //Grilla Historico de Informes
    if (this.params.funcionalidad === Funcionalidades.HistoricoInforme) {
      const descargar = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.Descargar &&
          x.clienteId === config.getClienteSesion()
      );
      if (descargar !== undefined && descargar !== null) {
        this.btnDescargar = true;
      } else {
        this.btnDescargar = false;
      }
    }

    //Funciones Grilla Usuarios (Solo "Ver Detalle" para Usuarios Transversales y de Sesion)
    if (this.params.funcionalidad === Funcionalidades.Usuarios) {
      const verDetalle = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.VerDetalle &&
          x.clienteId === config.getClienteSesion()
      );
      const cambiarPassword = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.CambiarPassword &&
          x.clienteId === config.getClienteSesion()
      );
      if (cambiarPassword !== undefined && cambiarPassword !== null) {
        this.btnCambiarContraseña = true;
      } else {
        this.btnCambiarContraseña = false;
      }

      if (this.params.data.tipo === TipoUsuario.Transversal) {
        this.btnEliminar = false;
        this.btnEditar = false;

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }

      if (this.params.data.esUsuarioSesion === true) {
        this.btnEliminar = false;
        this.btnEditar = false;
        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
    }
    //---

    //Funciones Grilla Usuarios Transversales (Solo "Ver Detalle" para Usuario de Sesion)
    if (this.params.funcionalidad === Funcionalidades.UsuariosTransversal) {
      if (this.params.data.esUsuarioSesion === true) {
        this.btnEliminar = false;
        this.btnEditar = false;
        this.btnDesbloquear = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
      const cambiarPassword = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.CambiarPassword &&
          x.clienteId === config.getClienteSesion()
      );
      if (cambiarPassword !== undefined && cambiarPassword !== null) {
        this.btnCambiarContraseña = true;
      } else {
        this.btnCambiarContraseña = false;
      }
    }
    //---

    //Funciones Grilla Usuarios Transversales (Solo "Ver Detalle" para Usuario ADMINTRACK)
    if (this.params.funcionalidad === Funcionalidades.UsuariosTransversal) {
      if (this.params.data.email === 'admintrack@gpschile.com') {
        this.btnEliminar = false;
        this.btnEditar = false;
        this.btnDesbloquear = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
    }
    //---

    //Funciones Grilla Roles (Solo "Ver Detalle" para Roles Transversales)
    if (this.params.funcionalidad === Funcionalidades.Roles) {
      if (this.params.data.tipo !== TipoRol.Local) {
        this.btnEliminar = false;
        this.btnEditar = false;
      }
    }
    //---

    //745 - Flota/GrupoDeZona - Consultar
    //Funciones Grilla Grupo de Zona (Solo "Ver Detalle" para Grupo de Zonas Base)
    if (this.params.funcionalidad === Funcionalidades.GrupoDeZona) {
      if (this.params.data.estado === EstadoEntidad.Sistema) {
        this.btnEliminar = false;
        this.btnEditar = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
    }
    //---

    if (this.params.funcionalidad === Funcionalidades.GrupoDeConductores) {
      if (this.params.data.estado === EstadoEntidad.Sistema) {
        this.btnEliminar = false;
        this.btnEditar = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
    }
    //745 - Flota/GrupoDeZona - Consultar
    //Funciones Grilla Flotas (Solo "Ver Detalle" para Flotas Base)
    if (this.params.funcionalidad === Funcionalidades.Flotas) {
      if (this.params.data.estado === EstadoEntidad.Sistema) {
        this.btnEliminar = false;
        this.btnEditar = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
      //09-2019: Desarrollo Compartir InformaciÃ³n
      if (this.params.data.esFlotaRecibe === true) {
        this.btnEliminar = false;
      }
    }
    //---

    //Grilla Compartir Información - Los item con estado "Compartido en Flota" no tienen Acciones
    if (this.params.funcionalidad === Funcionalidades.CompartirInformacion) {
      const dejarCompartirAccion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.DejarDeCompartir &&
          x.clienteId === config.getClienteSesion()
      );

      const verDetalleAccion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.VerDetalle &&
          x.clienteId === config.getClienteSesion()
      );

      switch (this.params.data.estadoCompartirInformacion) {
        case EstadoCompartirInformacion.PendienteDeAceptacion:
        case EstadoCompartirInformacion.Aceptada:
          if (dejarCompartirAccion !== undefined) {
            this.btnDejarDeCompartir = true;
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (verDetalleAccion !== undefined) {
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (
            dejarCompartirAccion === undefined &&
            verDetalleAccion === undefined
          ) {
            this.mostrarMenuAcciones = false;
          }
          break;
        case EstadoCompartirInformacion.Rechazada:
        case EstadoCompartirInformacion.DejarDeCompartir:
        case EstadoCompartirInformacion.DejarDeRecibir:
          if (verDetalleAccion !== undefined) {
            this.btnEditar = false;
            this.btnEliminar = false;
          } else {
            this.mostrarMenuAcciones = false;
          }
          break;
        case EstadoCompartirInformacion.CompartidoEnFlota:
          this.mostrarMenuAcciones = false;
          break;
      }
    }
    //---

    //Grilla Aceptar Información - Los item con estado "Compartido en Flota" no tienen Acciones
    if (this.params.funcionalidad === Funcionalidades.AceptarInformacion) {
      const aceptarInfoAccion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.Aceptar &&
          x.clienteId === config.getClienteSesion()
      );

      const rechazarInfoAccion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.Rechazar &&
          x.clienteId === config.getClienteSesion()
      );

      const dejarRecibirInfoAccion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.DejarDeRecibir &&
          x.clienteId === config.getClienteSesion()
      );

      const verDetalleAccion = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.VerDetalle &&
          x.clienteId === config.getClienteSesion()
      );

      switch (this.params.data.estadoCompartirInformacion) {
        case EstadoAceptarInformacion.Pendiente:
          if (aceptarInfoAccion !== undefined) {
            this.btnAceptar = true;
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (rechazarInfoAccion !== undefined) {
            this.btnRechazar = true;
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (verDetalleAccion !== undefined) {
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (
            aceptarInfoAccion === undefined &&
            rechazarInfoAccion === undefined &&
            verDetalleAccion === undefined
          ) {
            this.mostrarMenuAcciones = false;
          }
          break;
        case EstadoAceptarInformacion.Aceptada:
          if (dejarRecibirInfoAccion !== undefined) {
            this.btnDejarDeRecibir = true;
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (verDetalleAccion !== undefined) {
            this.btnEditar = false;
            this.btnEliminar = false;
          }
          if (
            dejarRecibirInfoAccion === undefined &&
            verDetalleAccion === undefined
          ) {
            this.mostrarMenuAcciones = false;
          }
          break;
        case EstadoAceptarInformacion.Rechazada:
        case EstadoAceptarInformacion.DejadaDeCompartirPorElCliente:
        case EstadoAceptarInformacion.DejarDeRecibir:
          if (verDetalleAccion !== undefined) {
            this.btnEditar = false;
            this.btnEliminar = false;
          } else {
            this.mostrarMenuAcciones = false;
          }
          break;
        case EstadoAceptarInformacion.CompartidoEnFlota:
          this.mostrarMenuAcciones = false;
          break;
      }
    }
    //---

    //06-03-2020 - Acciones - Solo "Ver Detalle" para "Consultar"
    if (this.params.funcionalidad === Funcionalidades.Acciones) {
      if (this.params.data.id === CodigoAccion.Consultar) {
        this.btnEliminar = false;
        this.btnEditar = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
    }

    //---
    //Tipo Mantenimiento base tendra solo ver detalle
    if (this.params.funcionalidad === Funcionalidades.TipoMantenimiento) {
      if (this.params.data.estado === EstadoEntidad.Sistema) {
        this.btnEliminar = false;
        this.btnEditar = false;

        const verDetalle = this.params.usuario.permisosUsuario.find(
          x =>
            x.moduloCodigo === this.params.funcionalidad &&
            x.accionCodigo === CodigoAccion.VerDetalle &&
            x.clienteId === config.getClienteSesion()
        );

        if (verDetalle !== undefined && verDetalle !== null) {
          this.mostrarMenuAcciones = true;
        } else {
          this.mostrarMenuAcciones = false;
        }
      }
    }

    //Enviar
    if (
      this.params.funcionalidad === Funcionalidades.AlertasVigilanti ||
      this.params.funcionalidad === Funcionalidades.OrdenesCompra
    ) {
      const enviar = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.Enviar &&
          x.clienteId === config.getClienteSesion()
      );
      if (enviar !== undefined && enviar !== null) {
        if (this.params.funcionalidad === Funcionalidades.OrdenesCompra) {
          this.btnEnviarText = 'Ver PDF';
        } else {
          this.btnEnviarText = 'Enviar Por Correo';
        }
        this.btnEnviar = true;
      } else {
        this.btnEnviar = false;
      }

      const verRef = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.VerReferencia &&
          x.clienteId === config.getClienteSesion()
      );
      if (verRef !== undefined && verRef !== null) {
        this.btnVerReferencia = true;
        this.btnVerReferenciaIcon = 'receipt_long';
        this.btnVerReferenciaText = 'Ver Referencia';
      } else {
        this.btnVerReferencia = false;
      }
    }
    //Ver PDF VerFacturaciones
    if (
      this.params.funcionalidad === Funcionalidades.VerFacturacion ||
      this.params.funcionalidad === Funcionalidades.MovimientoDispositivos
    ) {
      const verPDF = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.VerPdf &&
          x.clienteId === config.getClienteSesion()
      );
      if (verPDF !== undefined && verPDF !== null) {
        this.btnVerPdf = true;
        this.btnVerText = 'Documento PDF';
        this.btnVerIcon = 'receipt';
      } else {
        this.btnVerPdf = false;
      }

      const verRef = this.params.usuario.permisosUsuario.find(
        x =>
          x.moduloCodigo === this.params.funcionalidad &&
          x.accionCodigo === CodigoAccion.VerReferencia &&
          x.clienteId === config.getClienteSesion()
      );
      if (verRef !== undefined && verRef !== null) {
        this.btnVerReferencia = true;
        this.btnVerReferenciaIcon = 'receipt_long';
        this.btnVerReferenciaText = 'Ver Referencia';
      } else {
        this.btnVerReferencia = false;
      }
    }
  },
  mounted() {
    if (this.params.data.estado != undefined) {
      this.estadoEntidad = this.params.data.estado;
      if (this.params.data.estado == EstadoEntidad.Eliminado) {
        this.enabledDeleteBtn = false;
      }
    }

    if (
      this.params.eParentOfValue.baseURI.toString().indexOf('funcionalidad') >
      -1
    ) {
      this.btnEliminar = false;
    }
  },
});
</script>
<style scoped>
.v-menu {
  display: block;
}
</style>
